import CoreQuoteSlider from './CoreQuoteSlider';

export { type CoreQuoteSliderProps } from './CoreQuoteSlider';
export default CoreQuoteSlider;
